var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHrThreeDot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79688 12.75C3.79688 11.646 4.73021 10.75 5.88021 10.75C7.03021 10.75 7.96354 11.646 7.96354 12.75C7.96354 13.854 7.03021 14.75 5.88021 14.75C4.73021 14.75 3.79688 13.854 3.79688 12.75ZM13.1719 10.75C12.0219 10.75 11.0885 11.646 11.0885 12.75C11.0885 13.854 12.0219 14.75 13.1719 14.75C14.3219 14.75 15.2552 13.854 15.2552 12.75C15.2552 11.646 14.3219 10.75 13.1719 10.75ZM20.4635 10.75C19.3135 10.75 18.3802 11.646 18.3802 12.75C18.3802 13.854 19.3135 14.75 20.4635 14.75C21.6135 14.75 22.5469 13.854 22.5469 12.75C22.5469 11.646 21.6135 10.75 20.4635 10.75Z",
    fill: "#9C4900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_141569",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 10,
    width: 20,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79688 12.75C3.79688 11.646 4.73021 10.75 5.88021 10.75C7.03021 10.75 7.96354 11.646 7.96354 12.75C7.96354 13.854 7.03021 14.75 5.88021 14.75C4.73021 14.75 3.79688 13.854 3.79688 12.75ZM13.1719 10.75C12.0219 10.75 11.0885 11.646 11.0885 12.75C11.0885 13.854 12.0219 14.75 13.1719 14.75C14.3219 14.75 15.2552 13.854 15.2552 12.75C15.2552 11.646 14.3219 10.75 13.1719 10.75ZM20.4635 10.75C19.3135 10.75 18.3802 11.646 18.3802 12.75C18.3802 13.854 19.3135 14.75 20.4635 14.75C21.6135 14.75 22.5469 13.854 22.5469 12.75C22.5469 11.646 21.6135 10.75 20.4635 10.75Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_141569)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.671875,
    y: 0.75,
    width: 25,
    height: 24,
    fill: "#9C4900"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrThreeDot);
export default __webpack_public_path__ + "static/media/hr_three_dot.d0a9dab8094a618c9d75babf5497997f.svg";
export { ForwardRef as ReactComponent };